export default __webpack_public_path__ + "e2988146d6ab9cb638b0557565cc2789.svg";